import { render, staticRenderFns } from "./BrandableAddonModal.vue?vue&type=template&id=84c7468c&scoped=true&"
import script from "./BrandableAddonModal.vue?vue&type=script&lang=js&"
export * from "./BrandableAddonModal.vue?vue&type=script&lang=js&"
import style0 from "./BrandableAddonModal.vue?vue&type=style&index=0&id=84c7468c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c7468c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\corporate-builder\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84c7468c')) {
      api.createRecord('84c7468c', component.options)
    } else {
      api.reload('84c7468c', component.options)
    }
    module.hot.accept("./BrandableAddonModal.vue?vue&type=template&id=84c7468c&scoped=true&", function () {
      api.rerender('84c7468c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CorporateBuilder/components/AddonModal/BrandableAddonModal.vue"
export default component.exports